'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require('bluebird');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _index = require('../../../../index');

var _index2 = _interopRequireDefault(_index);

var _MatrixClientPeg = require('../../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _Modal = require('../../../../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _matrixJsSdk = require('matrix-js-sdk');

var _languageHandler = require('../../../../languageHandler');

var _Keyboard = require('../../../../Keyboard');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2018, 2019 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var RESTORE_TYPE_PASSPHRASE = 0;
var RESTORE_TYPE_RECOVERYKEY = 1;

/**
 * Dialog for restoring e2e keys from a backup and the user's recovery key
 */
exports.default = (0, _createReactClass2.default)({
    displayName: 'RestoreKeyBackupDialog',

    getInitialState: function getInitialState() {
        return {
            backupInfo: null,
            loading: false,
            loadError: null,
            restoreError: null,
            recoveryKey: "",
            recoverInfo: null,
            recoveryKeyValid: false,
            forceRecoveryKey: false,
            passPhrase: '',
            restoreType: null
        };
    },

    componentWillMount: function componentWillMount() {
        this._loadBackupStatus();
    },

    _onCancel: function _onCancel() {
        this.props.onFinished(false);
    },

    _onDone: function _onDone() {
        this.props.onFinished(true);
    },

    _onUseRecoveryKeyClick: function _onUseRecoveryKeyClick() {
        this.setState({
            forceRecoveryKey: true
        });
    },

    _onResetRecoveryClick: function _onResetRecoveryClick() {
        var _this = this;

        this.props.onFinished(false);
        _Modal2.default.createTrackedDialogAsync('Key Backup', 'Key Backup', import('../../../../async-components/views/dialogs/keybackup/CreateKeyBackupDialog'), {
            onFinished: function onFinished() {
                _this._loadBackupStatus();
            }
        });
    },

    _onRecoveryKeyChange: function _onRecoveryKeyChange(e) {
        this.setState({
            recoveryKey: e.target.value,
            recoveryKeyValid: _MatrixClientPeg2.default.get().isValidRecoveryKey(e.target.value)
        });
    },

    _onPassPhraseNext: function () {
        var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var recoverInfo;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            this.setState({
                                loading: true,
                                restoreError: null,
                                restoreType: RESTORE_TYPE_PASSPHRASE
                            });
                            _context.prev = 1;
                            _context.next = 4;
                            return (0, _bluebird.resolve)(_MatrixClientPeg2.default.get().restoreKeyBackupWithPassword(this.state.passPhrase, undefined, undefined, this.state.backupInfo));

                        case 4:
                            recoverInfo = _context.sent;

                            this.setState({
                                loading: false,
                                recoverInfo: recoverInfo
                            });
                            _context.next = 12;
                            break;

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](1);

                            console.log("Error restoring backup", _context.t0);
                            this.setState({
                                loading: false,
                                restoreError: _context.t0
                            });

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 8]]);
        }));

        function _onPassPhraseNext() {
            return _ref.apply(this, arguments);
        }

        return _onPassPhraseNext;
    }(),

    _onRecoveryKeyNext: function () {
        var _ref2 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            var recoverInfo;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            this.setState({
                                loading: true,
                                restoreError: null,
                                restoreType: RESTORE_TYPE_RECOVERYKEY
                            });
                            _context2.prev = 1;
                            _context2.next = 4;
                            return (0, _bluebird.resolve)(_MatrixClientPeg2.default.get().restoreKeyBackupWithRecoveryKey(this.state.recoveryKey, undefined, undefined, this.state.backupInfo));

                        case 4:
                            recoverInfo = _context2.sent;

                            this.setState({
                                loading: false,
                                recoverInfo: recoverInfo
                            });
                            _context2.next = 12;
                            break;

                        case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2['catch'](1);

                            console.log("Error restoring backup", _context2.t0);
                            this.setState({
                                loading: false,
                                restoreError: _context2.t0
                            });

                        case 12:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[1, 8]]);
        }));

        function _onRecoveryKeyNext() {
            return _ref2.apply(this, arguments);
        }

        return _onRecoveryKeyNext;
    }(),

    _onPassPhraseChange: function _onPassPhraseChange(e) {
        this.setState({
            passPhrase: e.target.value
        });
    },

    _onPassPhraseKeyPress: function _onPassPhraseKeyPress(e) {
        if (e.key === _Keyboard.Key.ENTER) {
            this._onPassPhraseNext();
        }
    },

    _onRecoveryKeyKeyPress: function _onRecoveryKeyKeyPress(e) {
        if (e.key === _Keyboard.Key.ENTER && this.state.recoveryKeyValid) {
            this._onRecoveryKeyNext();
        }
    },

    _loadBackupStatus: function () {
        var _ref3 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            var backupInfo;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            this.setState({
                                loading: true,
                                loadError: null
                            });
                            _context3.prev = 1;
                            _context3.next = 4;
                            return (0, _bluebird.resolve)(_MatrixClientPeg2.default.get().getKeyBackupVersion());

                        case 4:
                            backupInfo = _context3.sent;

                            this.setState({
                                loadError: null,
                                loading: false,
                                backupInfo: backupInfo
                            });
                            _context3.next = 12;
                            break;

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](1);

                            console.log("Error loading backup status", _context3.t0);
                            this.setState({
                                loadError: _context3.t0,
                                loading: false
                            });

                        case 12:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[1, 8]]);
        }));

        function _loadBackupStatus() {
            return _ref3.apply(this, arguments);
        }

        return _loadBackupStatus;
    }(),

    render: function render() {
        var _this2 = this;

        var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
        var Spinner = _index2.default.getComponent("elements.Spinner");

        var backupHasPassphrase = this.state.backupInfo && this.state.backupInfo.auth_data && this.state.backupInfo.auth_data.private_key_salt && this.state.backupInfo.auth_data.private_key_iterations;

        var content = void 0;
        var title = void 0;
        if (this.state.loading) {
            title = (0, _languageHandler._t)("Loading...");
            content = _react2.default.createElement(Spinner, null);
        } else if (this.state.loadError) {
            title = (0, _languageHandler._t)("Error");
            content = (0, _languageHandler._t)("Unable to load backup status");
        } else if (this.state.restoreError) {
            if (this.state.restoreError.errcode === _matrixJsSdk.MatrixClient.RESTORE_BACKUP_ERROR_BAD_KEY) {
                if (this.state.restoreType === RESTORE_TYPE_RECOVERYKEY) {
                    title = (0, _languageHandler._t)("Recovery Key Mismatch");
                    content = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            (0, _languageHandler._t)("Backup could not be decrypted with this key: " + "please verify that you entered the correct recovery key.")
                        )
                    );
                } else {
                    title = (0, _languageHandler._t)("Incorrect Recovery Passphrase");
                    content = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            (0, _languageHandler._t)("Backup could not be decrypted with this passphrase: " + "please verify that you entered the correct recovery passphrase.")
                        )
                    );
                }
            } else {
                title = (0, _languageHandler._t)("Error");
                content = (0, _languageHandler._t)("Unable to restore backup");
            }
        } else if (this.state.backupInfo === null) {
            title = (0, _languageHandler._t)("Error");
            content = (0, _languageHandler._t)("No backup found!");
        } else if (this.state.recoverInfo) {
            title = (0, _languageHandler._t)("Backup Restored");
            var failedToDecrypt = void 0;
            if (this.state.recoverInfo.total > this.state.recoverInfo.imported) {
                failedToDecrypt = _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)("Failed to decrypt %(failedCount)s sessions!", { failedCount: this.state.recoverInfo.total - this.state.recoverInfo.imported })
                );
            }
            content = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)("Restored %(sessionCount)s session keys", { sessionCount: this.state.recoverInfo.imported })
                ),
                failedToDecrypt
            );
        } else if (backupHasPassphrase && !this.state.forceRecoveryKey) {
            var DialogButtons = _index2.default.getComponent('views.elements.DialogButtons');
            var AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');
            title = (0, _languageHandler._t)("Enter Recovery Passphrase");
            content = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)("<b>Warning</b>: you should only set up key backup " + "from a trusted computer.", {}, { b: function b(sub) {
                            return _react2.default.createElement(
                                'b',
                                null,
                                sub
                            );
                        } })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)("Access your secure message history and set up secure " + "messaging by entering your recovery passphrase.")
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_RestoreKeyBackupDialog_primaryContainer' },
                    _react2.default.createElement('input', { type: 'password',
                        className: 'mx_RestoreKeyBackupDialog_passPhraseInput',
                        onChange: this._onPassPhraseChange,
                        onKeyPress: this._onPassPhraseKeyPress,
                        value: this.state.passPhrase,
                        autoFocus: true
                    }),
                    _react2.default.createElement(DialogButtons, { primaryButton: (0, _languageHandler._t)('Next'),
                        onPrimaryButtonClick: this._onPassPhraseNext,
                        hasCancel: true,
                        onCancel: this._onCancel,
                        focus: false
                    })
                ),
                (0, _languageHandler._t)("If you've forgotten your recovery passphrase you can " + "<button1>use your recovery key</button1> or " + "<button2>set up new recovery options</button2>", {}, {
                    button1: function button1(s) {
                        return _react2.default.createElement(
                            AccessibleButton,
                            { className: 'mx_linkButton',
                                element: 'span',
                                onClick: _this2._onUseRecoveryKeyClick
                            },
                            s
                        );
                    },
                    button2: function button2(s) {
                        return _react2.default.createElement(
                            AccessibleButton,
                            { className: 'mx_linkButton',
                                element: 'span',
                                onClick: _this2._onResetRecoveryClick
                            },
                            s
                        );
                    }
                })
            );
        } else {
            title = (0, _languageHandler._t)("Enter Recovery Key");
            var _DialogButtons = _index2.default.getComponent('views.elements.DialogButtons');
            var _AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');

            var keyStatus = void 0;
            if (this.state.recoveryKey.length === 0) {
                keyStatus = _react2.default.createElement('div', { className: 'mx_RestoreKeyBackupDialog_keyStatus' });
            } else if (this.state.recoveryKeyValid) {
                keyStatus = _react2.default.createElement(
                    'div',
                    { className: 'mx_RestoreKeyBackupDialog_keyStatus' },
                    '\uD83D\uDC4D ',
                    (0, _languageHandler._t)("This looks like a valid recovery key!")
                );
            } else {
                keyStatus = _react2.default.createElement(
                    'div',
                    { className: 'mx_RestoreKeyBackupDialog_keyStatus' },
                    '\uD83D\uDC4E ',
                    (0, _languageHandler._t)("Not a valid recovery key")
                );
            }

            content = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)("<b>Warning</b>: you should only set up key backup " + "from a trusted computer.", {}, { b: function b(sub) {
                            return _react2.default.createElement(
                                'b',
                                null,
                                sub
                            );
                        } })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)("Access your secure message history and set up secure " + "messaging by entering your recovery key.")
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_RestoreKeyBackupDialog_primaryContainer' },
                    _react2.default.createElement('input', { className: 'mx_RestoreKeyBackupDialog_recoveryKeyInput',
                        onChange: this._onRecoveryKeyChange,
                        onKeyPress: this._onRecoveryKeyKeyPress,
                        value: this.state.recoveryKey,
                        autoFocus: true
                    }),
                    keyStatus,
                    _react2.default.createElement(_DialogButtons, { primaryButton: (0, _languageHandler._t)('Next'),
                        onPrimaryButtonClick: this._onRecoveryKeyNext,
                        hasCancel: true,
                        onCancel: this._onCancel,
                        focus: false,
                        primaryDisabled: !this.state.recoveryKeyValid
                    })
                ),
                (0, _languageHandler._t)("If you've forgotten your recovery passphrase you can " + "<button>set up new recovery options</button>", {}, {
                    button: function button(s) {
                        return _react2.default.createElement(
                            _AccessibleButton,
                            { className: 'mx_linkButton',
                                element: 'span',
                                onClick: _this2._onResetRecoveryClick
                            },
                            s
                        );
                    }
                })
            );
        }

        return _react2.default.createElement(
            BaseDialog,
            { className: 'mx_RestoreKeyBackupDialog',
                onFinished: this.props.onFinished,
                title: title
            },
            _react2.default.createElement(
                'div',
                null,
                content
            )
        );
    }
});
module.exports = exports['default'];
//# sourceMappingURL=RestoreKeyBackupDialog.js.map